import { AuthService } from './../../shared/route-guards/services/auth.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { SnotifyService } from 'ng-snotify';
import { DatePipe } from '@angular/common';
import { Local } from 'src/app/shared/models/local.model';
import { FilterItem } from 'src/app/shared/base-reporting/models/filter-item.interface';
import { FilterCallback } from 'src/app/shared/base-reporting/models/filter-callback.interface';
import { RowAction } from 'src/app/shared/base-reporting/models/row-actions.interface';
import { RowActionCallback } from 'src/app/shared/base-reporting/models/row-action-callback.interface';
import { LocalsService } from '../locals.service';
@Component({
  selector: 'app-locals-log',
  templateUrl: './locals-log.component.html',
  styleUrls: ['./locals-log.component.css']
})
export class LocalsLogComponent implements OnInit {
  viewFlag = false;
  viewAdminApprovalFlag = false;
  @ViewChild('viewLoc', { static: true }) viewLoc: ElementRef;
  @ViewChild('viewAdminApproval', { static: true })
  viewAdminApproval: ElementRef;

  local = new Local();
  get data(): Array<TableViewItem> {
    return this.Data
      .filter(row => {
        if (this.currentFilterObject.active) {
          return row.active
            .toLowerCase()
            .includes(this.currentFilterObject.active.toLowerCase());
        }
        return true;
      })
      .filter(row => {
        if (this.currentFilterObject.adminApproval) {
          return this.currentFilterObject.adminApproval.includes(
            row.adminApproval
          );
        }
        return true;
      });
  }
  set data(v: Array<TableViewItem>) {
    this.Data = v;
  }
  private Data = [] as Array<TableViewItem>;

  tableColumns = [
    'firstName',
    'lastName',
    'city',
    'country',
    'rating',
    'active',
    'adminApproval'
  ];
  rowActions: Array<RowAction> = [
    {
      type: 'icon',
      slug: 'viewProfile',
      class: 'btn',
      iconClasses: 'fa fa-eye'
    },
    {
      type: 'icon',
      slug: 'viewAdminApproval',
      class: 'btn',
      iconClasses: 'fa fa-edit'
    }
  ];
  reportFilter: Array<FilterItem> = [
    {
      fieldName: 'active',
      fieldDisplayName: 'Active ',
      fieldType: 'text'
    },
    {
      fieldName: 'adminApproval',
      fieldDisplayName: 'Admin Approval ',
      fieldType: 'select',
      multiple: false,
      hasSelectAll: false,
      defaultValue: null,
      options: [
        { value: 'APPROVED', display: 'Approved' },
        { value: 'PENDING', display: 'Pending' },
        { value: 'DECLINED', display: 'Declined' }
      ]
    }
  ];


  constructor(private localsApi: LocalsService, private router: Router, private authService: AuthService) { }

  currentFilterObject = {} as FilterModel;
  role = '';

  ngOnInit() {
    // this.sharedService.getLanguages().then(response => {
    //   this.reportFilter[1].options = response.data.languages.map(l => ({value: l.id, display: l.name}))
    // })
    
    this.role = this.authService.role;
    this.addEditBtn();
    this.fetchAllLocals();
  }

  onFilter(event: FilterCallback) {
    this.currentFilterObject = event.filter;
  }

  private fetchAllLocals() {
    this.localsApi.getAllLocals().subscribe(response => {
      // console.log(response)
      this.data = response.data.locals.map(r => {
        this.local = r;
        // console.log(r)
        if (r.city == null) {
          r.city = '-';
          r.country = '-';
        }
        let rate = '';
        if (r.rating == null) {
          rate = '-';
        } else {
          rate = r.rating;
        }
        return {
          uuid: r.uuid,
          firstName: r.firstName,
          lastName: r.lastName,
          city: r.city,
          country: r.country,
          rating: rate,
          active: String(r.active),
          adminApproval: r.LocalInfo.adminApproval
        } as TableViewItem;
      });
    });
  }
  rowActionCB(event: RowActionCallback) {
    switch (event.action) {
      case 'viewProfile':
        this.viewLoc.nativeElement.click();
        this.viewFlag = true;
        this.local = event.on;
        break;
      case 'viewAdminApproval':
        this.viewAdminApprovalFlag = true;
        this.viewAdminApproval.nativeElement.click();
        this.local = event.on;
        break;
      case 'editLocal':
        this.editLocal(event.on.uuid);
        break;
      default:
        console.error('this is a mistake!');
    }
  }
  editLocal(id) {
    this.router.navigate(['/locals/edit/' + id]);
  }

  fetchTable(event) {
    if (event[`flag`] === true) {
      this.fetchAllLocals();
    }
  }


  addEditBtn() {
    if (this.role === 'SuperAdmin') {
      this.rowActions.push(
        {
          type: 'icon',
          slug: 'editLocal',
          class: 'btn',
          iconClasses: 'fas fa-user-edit'
        }
      )
    }
  }
}

interface TableViewItem {
  firstName?: string;
  lastName?: string;
  city?: string;
  country?: string;
  rating?: string;
  active?: string;
  adminApproval?: string;
}

interface FilterModel {
  active?: string;
  adminApproval?: string;
}
